import { useUI } from '@/state/store';
import { TextButton } from '@/components/ui/primitives';
import { useTwin } from '../../store';
import { GROUND_STATION_ROOMS, GROUND_STATION_RACKS } from '../../data/groundStation';

/** One room picker and three physical cabinet choices, with no floating card over the model. */
export function GroundStationControls() {
  const selected = useUI((s) => s.selection.subsystemId);
  const inspect = (id: string) => {
    useUI.getState().select({ subsystemId: id === 'main' ? null : id });
    if (id === 'main') useTwin.getState().requestCamera({ poseId: 'main' });
    else useTwin.getState().requestCamera({ subsystemId: id });
  };
  return (
    <>
      <select
        aria-label="Ground station room"
        value=""
        onChange={(e) => inspect(e.target.value)}
        className="max-w-48 rounded-control border border-hairline bg-inset px-2 py-1 text-xs text-ink-2"
      >
        <option value="" disabled>
          Room views
        </option>
        <option value="main">Whole facility</option>
        {GROUND_STATION_ROOMS.map((room) => (
          <option key={room.id} value={room.id}>
            {room.label}
          </option>
        ))}
      </select>
      <div role="group" aria-label="Processing cabinets" className="flex shrink-0 items-center gap-1">
        <span className="mr-1 text-[10px] uppercase tracking-wider text-ink-3">Racks</span>
        {GROUND_STATION_RACKS.map((rack) => (
          <TextButton
            key={rack.id}
            active={selected === rack.id}
            onClick={() => inspect(rack.id)}
            title={rack.description}
            aria-label={`Inspect ${rack.label} rack`}
            className="whitespace-nowrap px-2"
          >
            {rack.short}
          </TextButton>
        ))}
      </div>
    </>
  );
}
